import React from 'react';

import Table from '@components/Base/Table';
import { CustomColumnDef } from '@components/Base/Table/types';
import { Exam } from '@containers/exams/types';

interface ExamTableProps {
  exams: Exam[];
  columns: CustomColumnDef<Exam>[];
  isLoading: boolean;
}

const WorkFlowTable: React.FC<ExamTableProps> = (props) => {
  const { exams, columns, isLoading } = props;
  return (
    <div className="h-full">
      <Table<Exam>
        data={exams}
        columns={columns}
        isMultiselect={false}
        isLoading={isLoading}
        pagination={{ pageIndex: 0, pageSize: 10 }}
        pageCount={0}
        setPagination={() => {}}
      />
    </div>
  );
};

export default WorkFlowTable;
